export default __webpack_public_path__ + "assets/images/fde33519b736843aebed41551564e2de.webp";